<div *ngIf="layout === 'row'" 
    class="search-filters md:_shadow-light"
    [ngClass]="disabled ? '_pointer-events-none' : ''">
    <div *ngIf="disabled" class="_mask _z-10 _opacity-60"></div>
    <app-overflow-container>
        <form [formGroup]="formGroup" class="container">

            <div class="filter filter-radio-group-container">
                <label class="_chip-selectable-checkbox">
                    <input class="_checkbox" type="checkbox" formControlName="includeProperties" id="standalone-villa-label">
                    <span class="_text-md label" for="standalone-villa-label" tabindex="0" role="checkbox" aria-checked="false">Stand-alone Villa</span>
                </label>
                <label class="_chip-selectable-checkbox">
                    <input class="_checkbox" type="checkbox" formControlName="includeHotels" id="hotel-suites-label">
                    <span class="_text-md label" for="hotel-suites-label" tabindex="0" role="checkbox" aria-checked="false">Hotel suites</span>
                </label>
            </div>

            <div class="filter filter-type-incremental">
                <div class="_mr-2 _text-md">Bedrooms</div>
                <div class="filter-input-container">
                    <app-flok-number-input formControlName="bedrooms" max="30" min="0"></app-flok-number-input>
                </div>
                <span class='filter-icon-container' (click)="clearFilters('bedrooms')">
                    <i class="fa-light fa-arrows-rotate"></i>
                </span>
            </div>

            <div class="filter filter-type-incremental">
                <div class="_mr-2 _text-md">Bathrooms</div>
                <div class="filter-input-container">
                    <app-flok-number-input formControlName="bathrooms" max="30" min="0"></app-flok-number-input>
                </div>
                <span class='filter-icon-container' (click)="clearFilters('bathrooms')">
                    <i class="fa-light fa-arrows-rotate"></i>
                </span>
            </div>

            <div id="priceSlider" class="filter-price-slider">
                <ngx-slider [(value)]="minValue"
                            [(highValue)]="maxValue"
                            [options]="options"
                            (userChangeEnd)="search()">
                </ngx-slider>
                <span class='filter-icon-container' (click)="resetPriceRange()">
                    <i class="fa-light fa-arrows-rotate"></i>
                </span>
            </div>

            <div class="filter-show-more-btn-container _relative">
                <div *ngIf="selectedExtendedFilterCount" 
                    class="_pill-circle _absolute _-right-2 _-top-nudge-7 _h-5 _w-5 _p-0 _text-xs _z-10"><span>{{selectedExtendedFilterCount}}+</span></div>
                <button (click)="openFiltersModal()" class="_button-secondary">
                    <i class="fa-light fa-sliders _mr-1"></i>
                    <span>Filters</span>
                </button>
            </div>
        </form>
    </app-overflow-container>
</div>

<div *ngIf="layout === 'col'">
    <form [formGroup]="formGroup">
        <div class="_pb-7 _border-b _border-transparency-black-5">
            <div class="_h4 _mb-4">Types</div>
            <div class="_flex _flex-row _gap-2">
                <label class="_chip-selectable-checkbox">
                    <input class="_checkbox" type="checkbox" formControlName="includeProperties" id="standalone-villa-label">
                    <span class="_text-md label" for="standalone-villa-label" tabindex="0" role="checkbox" aria-checked="false">Stand-alone Villa</span>
                </label>
                <label class="_chip-selectable-checkbox">
                    <input class="_checkbox" type="checkbox" formControlName="includeHotels" id="hotel-suites-label">
                    <span class="_text-md label" for="hotel-suites-label" tabindex="0" role="checkbox" aria-checked="false">Hotel suites</span>
                </label>
            </div>
        </div>

        <div class="_pb-7 _border-b _border-transparency-black-5">
            <div class="_h4 _my-4">Rooms</div>
            <div class="_flex _flex-col _gap-2">
                <div class="filter filter-type-incremental">
                    <div class="_mr-2 _text-md _min-w-16">Bedrooms</div>
                    <div class="filter-input-container">
                        <app-flok-number-input formControlName="bedrooms" max="30" min="0"></app-flok-number-input>
                    </div>
                    <span class='filter-icon-container' (click)="clearFilters('bedrooms')">
                        <i class="fa-light fa-arrows-rotate"></i>
                    </span>
                </div>
        
                <div class="filter filter-type-incremental">
                    <div class="_mr-2 _text-md _min-w-16">Bathrooms</div>
                    <div class="filter-input-container">
                        <app-flok-number-input formControlName="bathrooms" max="30" min="0"></app-flok-number-input>
                    </div>
                    <span class='filter-icon-container' (click)="clearFilters('bathrooms')">
                        <i class="fa-light fa-arrows-rotate"></i>
                    </span>
                </div>
            </div>
        </div>

        <div class="_pb-7 _border-b _border-transparency-black-5">
            <div class="_flex _flex-row _items-center _justify-between">
                <div class="_h4 _my-4">Nightly Rates</div>
                <div class="_link" (click)="resetPriceRange()">
                    <span class="_text-sm">Clear all </span>
                    <i class="fa-light fa-arrows-rotate _text-md"></i>
                </div>
            </div>
            <div id="priceSlider" class="filter-price-slider">
                <ngx-slider 
                    [(value)]="minValue"
                    [(highValue)]="maxValue"
                    [options]="options"
                    (userChangeEnd)="search()">
                </ngx-slider>
            </div>
        </div>
    </form>

    <app-search-filters-extended
        [moreFilters]="moreFilters"
        [listingCount]="listingsOnMapCount"
        ($selectedFilterCountChanged)="onSelectedFilterCountChanged($event)"
        ($moreFiltersChange)="onMoreFiltersChanged($event)">
    </app-search-filters-extended>
</div>
